import React from "react";
import { money } from "@/lib/financeApi";

const hrs = (r) => (r.reg_hours == null ? "—" : `${+r.reg_hours.toFixed(2)}${r.ot_hours ? ` + ${+r.ot_hours.toFixed(2)} OT` : ""}`);

/** Per-resident hours, bill rate per hour and line total (same figures as the invoice PDF). */
export function ResidentBreakdown({ rows = [] }) {
  if (!rows.length) return null;
  const hasHours = rows.some((r) => r.reg_hours != null);
  const reg = rows.reduce((a, r) => a + (r.reg_hours || 0), 0);
  const ot = rows.reduce((a, r) => a + (r.ot_hours || 0), 0);
  return (
    <div data-testid="fin-inv-breakdown" className="border border-white/10 rounded-sm overflow-x-auto">
      <table className="w-full text-xs min-w-[340px]">
        <thead className="whitespace-nowrap text-[10px] uppercase tracking-wider text-nex-muted bg-white/[0.03]">
          <tr><th className="text-left px-2 sm:px-3 py-2">Resident</th><th className="text-right px-2 sm:px-3 py-2">Hours</th>
            <th className="text-right px-2 sm:px-3 py-2">Cost/hr</th><th className="text-right px-2 sm:px-3 py-2">Total</th></tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={`${r.resident_id}-${i}`} data-testid={`fin-inv-breakdown-row-${i}`} className="border-t border-white/5">
              <td className="px-2 sm:px-3 py-1.5 text-nex-silver">{r.name}{r.item && <span className="text-nex-muted"> · {r.item}</span>}</td>
              <td className="whitespace-nowrap px-2 sm:px-3 py-1.5 text-right font-mono" data-testid={`fin-inv-breakdown-hours-${i}`}>{hrs(r)}</td>
              <td className="whitespace-nowrap px-2 sm:px-3 py-1.5 text-right font-mono" data-testid={`fin-inv-breakdown-rate-${i}`}>{r.rate == null ? "—" : `${money(r.rate)}`}</td>
              <td className="px-2 sm:px-3 py-1.5 text-right font-mono text-white" data-testid={`fin-inv-breakdown-total-${i}`}>{r.total == null ? "—" : money(r.total)}</td>
            </tr>
          ))}
          {hasHours && (
            <tr className="border-t border-nex-gold/40 font-semibold" data-testid="fin-inv-breakdown-sum">
              <td className="px-2 sm:px-3 py-1.5">Total hours</td>
              <td className="whitespace-nowrap px-2 sm:px-3 py-1.5 text-right font-mono">{+reg.toFixed(2)}{ot ? ` + ${+ot.toFixed(2)} OT` : ""}</td>
              <td />
              <td className="px-2 sm:px-3 py-1.5 text-right font-mono text-white">{money(rows.reduce((a, r) => a + (r.total || 0), 0))}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
